const fileLine = require("assets/v1.1/icons/Core/File/line.svg") + "#line";

export const File = {
  Line: fileLine,
};
